<template>
  <div class="relative overflow-hidden">
    <div
      class="h-full w-full"
      :class="isFeatureAllowed ? '' : 'pointer-events-none opacity-40 select-none'"
    >
      <slot :allowed="isFeatureAllowed" />
    </div>
    <div
      v-if="(!hideTitle && !isFeatureAllowed) || isLoading"
      class="absolute inset-0 flex flex-col items-center justify-center bg-surface-900/60 text-surface-0 text-center"
    >
      <SquareLoader v-if="isLoading" class="scale-50" />
      <p v-if="!hideTitle && !isFeatureAllowed && !isLoading">{{ message }}</p>
      <button
        v-if="actionText && !isFeatureAllowed && !isLoading"
        type="button"
        class="mt-2 underline hover:text-primary-400 duration-300"
        @click="emit('action')"
      >
        {{ actionText }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { AccountConfigKey } from "@/types/account";
import SquareLoader from "./SquareLoader.vue";
import { get } from "lodash-es";

const props = defineProps<{
  feature: AccountConfigKey;
  title?: string;
  allowIfUnspecified?: boolean;
  hideTitle?: boolean;
  actionText?: string;
}>();

const emit = defineEmits(["action"]);
const { t } = withI18nHelpers();
const { isLoading, data } = useAccountFeatureConfigurationRequest();
const message = computed(() => (props.title ? props.title : t("featureNotAvailable")));

const isFeatureAllowed = computed(() => {
  if (!data.value || !props.feature) return !!props.allowIfUnspecified;
  const feature = get(data.value, props.feature);
  if (feature === undefined) return !!props.allowIfUnspecified;
  return feature === true; //in case an object is referenced by accident
});
</script>
